"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "93huuw",
  styles: "justify-content:space-between;.menu-item-extras{display:none;}.menu-item-options{display:inline-flex;}"
} : {
  name: "1aud7gv-base",
  styles: "justify-content:space-between;.menu-item-extras{display:none;}.menu-item-options{display:inline-flex;};label:base;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var base = function base(_ref2) {
  var theme = _ref2.theme,
      hasBackground = _ref2.hasBackground,
      isSubMenuItem = _ref2.isSubMenuItem,
      tight = _ref2.tight,
      highlight = _ref2.highlight,
      hasMoreOptions = _ref2.hasMoreOptions;
  return /*#__PURE__*/(0, _react.css)("font-size:inherit;font-weight:", isSubMenuItem ? theme.fontWeight.normal : theme.fontWeight.medium, ";color:", highlight ? theme.color.mainNav.highlightColor : 'inherit', ";height:", theme.spacing[14], ";padding-left:", tight ? theme.spacing[5] : theme.spacing[10], ";padding-right:", tight ? theme.spacing[5] : theme.spacing[6], ";display:flex;align-items:center;width:100%;border-radius:6px;text-decoration:none;transition:none;&>svg{width:", theme.spacing[10], ";height:", theme.spacing[10], ";vertical-align:middle;margin-right:2px;flex-shrink:0;color:", theme.color.mainNav.iconColor, ";}&:hover{background-color:", theme.color.mainNav.itemBackgroundHover, ";", hasMoreOptions && _ref, ";.count{color:", theme.color.mainNav.countColorHover, ";}.alert{background-color:", theme.color.mainNav.alertColorHover, ";}}&.active{background-color:transparent;", isSubMenuItem && /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;")), " .count{color:", theme.color.mainNav.countColorActive, ";}.alert{background-color:", theme.color.mainNav.alertColorActive, ";}}", hasBackground && /*#__PURE__*/(0, _react.css)("background-color:", theme.color.mainNav.itemBackgroundActive, "!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var count = function count(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-shrink:0;font-weight:", theme.fontWeight.normal, ";color:", theme.color.mainNav.countColor, ";transition:color 0.2s;&:empty{visibility:hidden;}" + (process.env.NODE_ENV === "production" ? "" : ";label:count;"));
};

var isNew = function isNew(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.brand['300'], ";border-radius:", theme.spacing[6], ";line-height:", theme.spacing[11], ";display:inline-block;" + (process.env.NODE_ENV === "production" ? "" : ";label:isNew;"));
};

var alert = function alert(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-shrink:0;width:", theme.spacing[5], ";height:", theme.spacing[5], ";display:inline-block;background-color:", theme.color.mainNav.alertColor, ";border-radius:50%;transition:background-color 0.2s;" + (process.env.NODE_ENV === "production" ? "" : ";label:alert;"));
};

var extras = function extras(theme) {
  return /*#__PURE__*/(0, _react.css)("&>*+*{margin-left:", theme.spacing[3], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:extras;"));
};

var arrow = function arrow(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[11], "!important;height:", theme.spacing[11], "!important;transform:translateY(1px);margin-left:1px;transition:transform 0.2s;" + (process.env.NODE_ENV === "production" ? "" : ";label:arrow;"));
};

var openedArrow = process.env.NODE_ENV === "production" ? {
  name: "1qife6r",
  styles: "transform:translateY(1px) rotate(90deg)"
} : {
  name: "1mxfkwu-openedArrow",
  styles: "transform:translateY(1px) rotate(90deg);label:openedArrow;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var submenu = function submenu(theme) {
  return /*#__PURE__*/(0, _react.css)("padding-left:", theme.spacing[10], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:submenu;"));
};

var optionsBtn = function optionsBtn(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[12], ";height:", theme.spacing[12], ";margin-right:-", theme.spacing[3], ";display:none;&:not(:disabled)::before{background-color:", theme.color.mainNav.optionsBtnBackgroundHover, ";}svg{width:", (0, _util.rem)(18), ";height:", (0, _util.rem)(18), ";color:", theme.color.mainNav.optionsIconColor, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:optionsBtn;"));
};

var moreOptionsDropdown = /*#__PURE__*/(0, _react.css)("min-width:", (0, _util.rem)(192), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:moreOptionsDropdown;"));

var extraIconBase = function extraIconBase(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-shrink:0;color:", theme.color.mainNav.iconColor, ";svg{width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:extraIconBase;"));
};

var extraIconPrimary = function extraIconPrimary(theme) {
  return /*#__PURE__*/(0, _react.css)(extraIconBase(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:extraIconPrimary;"));
};

var extraIconWarning = function extraIconWarning(theme) {
  return /*#__PURE__*/(0, _react.css)(extraIconBase(theme), ";color:", theme.color.mainNav.warningIconColor, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:extraIconWarning;"));
};

var extraIcon = {
  primary: extraIconPrimary,
  warning: extraIconWarning
};
var styles = {
  base: base,
  count: count,
  isNew: isNew,
  arrow: arrow,
  openedArrow: openedArrow,
  submenu: submenu,
  alert: alert,
  extras: extras,
  optionsBtn: optionsBtn,
  moreOptionsDropdown: moreOptionsDropdown,
  extraIcon: extraIcon
};
exports.styles = styles;
//# sourceMappingURL=MenuItem.styles.js.map